import { fetch } from '@utils/utils';

export const fetchReport = ({ addError }) => async (reportId, input) => {
  try {
    const response = await fetch(`/metropolis/api/reports/${reportId}/generate`, {
      method: 'POST',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify(input)
    });

    if (response.ok) {
      const blob = await response.blob();
      return { blob, headers: response.headers };
    } else {
      const error = await response.text();
      addError(error);
    }
  } catch (err) {
    addError(err.message);
  }
  return {};
};

export const getReportDetail = ({ addError }) => async reportId => {
  try {
    const response = await fetch(`/metropolis/api/report/forms?reportId=${reportId}`);
    let report = null;
    try {
      report = await response.json();
    } catch (err) {
      console.log('report without detail: ', reportId);
    }

    return report;
  } catch (err) {
    addError(err.message);
  }
  return null;
};



// WEBPACK FOOTER //
// ./src/components/exportButton/_exportButtonActions.ts